module.exports = __webpack_public_path__ + "img/PecuniaLogo.863655ef.png";